export default __webpack_public_path__ + "static/media/digimonLogo.d748b99c.png";